import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { AiFillWarning, AiOutlineCamera } from 'react-icons/ai'
import PhoneInput from "./phone-input";
import CountryInput from './country-input';
import PostalCode from "components/postal-code/postal-code";
import DateInput from "components/date-input/date-input";
import InputMask from 'react-input-mask';
import t from 'helpers/I18n'

const InputField = (props) => {

    // Global props
    const { type, name, label, value, error, getInputValue, getDataFromContext, max, notBirthdate, disabled, getPostalValidity, noPast, noFuture, enterpriseToCreate } = props
    // Props for checkbox
    const { checkboxLabel, checked, checkboxlabelbold, emitCheckbox } = props

    // Props for phone
    const { phoneCode } = props

    // Props for country
    const { exclude, useDefault } = props

    // Props for select
    const { options, defaultSelect } = props

    // Props for NN && BCE validation
    const { isNNumber, isBCE } = props

    // id file input
    const {getInputFlie, content} = props

    /////////////////////////////////////////////////////////////////////////////////////////
 
    const initInputValut = value ? value : type === "checkbox" ? 0 : ""
    const [inputValue, setInputValue] = useState(initInputValut)

    useEffect(() => {
            setInputValue(value ? value : type === "checkbox" ? 0 : "")
    }, [value])
    
    const setInput = (e) => {
        setInputValue(e)
    }

    useEffect(() => {
        getInputValue && getInputValue(name, inputValue)
    }, [inputValue])


    //  validation method
    const noSpecialChar = e => /[&|@"#()§^¨!{}_[\]*$%?,.;:\/+=~\\<>°]/.test(e)
    const noSpecialCharNoDigit = e => /[0-9&|@"#()§^¨!{}_[\]*$%?,.;:\/+=~\\<>°]/.test(e)
    const noEmailSpecialChar = e => /[<>;\\]/.test(e)

    const NNumberFormat = (e) => {
        if (e.target.value.length < 1) {
            setInput("")
        }
        if (e.target.value.length < 15 && e.target.value.length > 0) {
            if (/^[0-9]*$/.test(e.target.value)) {
                if (e.target.value.length === 11) {
                    let value = e.target.value.replace(/[0-9_]{2}?/, '$&.')
                        .replace(/.[0-9_]{2}?/, '$&.')
                        .replace(/.[0-9_]{2}.[0-9_]{2}?/, '$&-')
                        .replace(/-[0-9_]{3}?/, '$&.')
                    setInput(value)
                } else {
                    let value = e.target.value.match(/\d/g).join("")
                    setInput(value)
                }
            } else {
                const v = e.target.value.match(/\d/g)
                if (v) {
                    let value = v.join("")
                    setInput(value)
                }
            }
        }
    }
    const BCEFormat = (e) => {
        if (e.target.value.length < 1) {
            setInput("")
        }
        if (e.target.value.length < 12 && e.target.value.length > 0) {
            if (/^[0-9]*$/.test(e.target.value)) {
                if (e.target.value.length === 10) {
                    let value = e.target.value.replace(/[0-9_]{4}?/, '$&.')
                        .replace(/[0-9_]{4}.[0-9_]{3}?/, '$&.')

                    setInput(value)
                } else {
                    let value = e.target.value.match(/\d/g).join("")
                    setInput(value)
                }
            } else {
                const v = e.target.value.match(/\d/g)
                if (v) {
                    let value = v.join("")
                    setInput(value)
                }
            }
        }
    }

    // Event Handler
    const handleInputChange = (e) => {
        const value = e.target.value
        cleanErrorMessage()

        const checkMax = max || 50

        if (type === "date" || isNNumber) {
            setInput(value.includes('/') ? e.target.value : e.target.value.split('-').reverse().join('/'))
        } else if (isBCE) {
            const firstNum = value.charAt(0)
            const val = value.split('').includes("_")
            const valAll = value.split('.').join('').split('').every(a => a === "_")
            const autorisedBCEFirtsNum = ["0", "1"]
            if ((firstNum !== "_" && !autorisedBCEFirtsNum.includes(firstNum)) || (!autorisedBCEFirtsNum.includes(firstNum) && val)) {
                setInputError({ name, error: t('error_messages.HBHE-0310') })
                
                if (window.PageBus && !valAll) {
                    window.PageBus.publish("analyticsServices", {
                        pageID: "onboarding",
                        errorMessage: t('error_messages.HBHE-0310') ,
                        trackMethod: "errorMessage"
                    }
                );
            }
                setInput("_")
            } else { setInput(value) }
            if (valAll) { cleanErrorMessage() }
    
        } else if (type === "email" || name === "enterprise_name") {
            if (noEmailSpecialChar(value)) {
                setInputError({ name, error: t('error_messages.special_caracters') })
                if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
                        pageID: "onboarding",
                        errorMessage: t('error_messages.special_caracters'),
                        trackMethod: "errorMessage"
                    }
                );
            }
                setInput(inputValue.length > 0 ? inputValue : " ")
            } else if (value.length <= checkMax) {
                cleanErrorMessage()
                setInput(value)
            }
        } else if (name === "first_name" || name === "last_name") {
            if (noSpecialCharNoDigit(value)) {
                setInputError({ name, error: t('error_messages.special_caracters') })
                    if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
                        pageID: "onboarding",
                        errorMessage: t('error_messages.special_caracters'),
                        trackMethod: "errorMessage"
                    }
                );
            }
                setInput(inputValue.length > 0 ? inputValue : " ")
            } else {
                cleanErrorMessage()
                if (value.length <= checkMax) {
                    setInput(value)
                }
            }
        } else {
            if (noSpecialChar(value)) {
                setInputError({ name, error: t('error_messages.special_caracters') })
                 if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
                    pageID: "onboarding",
                    errorMessage: t('error_messages.special_caracters'),
                    trackMethod: "errorMessage"
                    }
                );
            }
                setInput(inputValue.length > 0 ? inputValue : " ")
            } else {
                console.log('pas de special char ???')
                cleanErrorMessage()
                if (value.length <= checkMax) {
                    isNNumber && NNumberFormat(e)
                    isBCE && BCEFormat(e)
                    !isNNumber && !isBCE && setInput(value)
                }
            }
         } 
    }

    const onBlurValidation = (e) => {
        // '^[a-zA-Z0-9_!#$%&'*+/=?`{|}~^.-]+@[a-zA-Z0-9.-]+$'
        // ^[a-zA-Z0-9.-.!#$%&'*+/=?^_`{([|\])}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-][a-zA-Z0-9-]+$
        // ^[a-zA-Z0-9.-.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-][a-zA-Z0-9-]+$
        // if (type === "email" && !/^[a-zA-Z0-9_!#$%&'*+/=?`{|}~^.-]+@[a-zA-Z0-9.-]+$/.test(e.target.value)) {
        if (type === "email" && !/^[a-zA-Z0-9_!#$%&'*+/=?`{|}~^.-]+@[a-zA-Z0-9_!#$%&'*+/=?`{|}~^.-]+\.+[a-zA-Z0-9-][a-zA-Z0-9-]+$/.test(e.target.value)) {
            setInputError({ id: "email", error: t('error_messages.email_format') })
                       if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
pageID: "onboarding",
errorMessage: t('error_messages.email_format'),
trackMethod: "errorMessage"
                    }
                );
            }
            setInput(inputValue.length > 0 ? inputValue : " ")
        }
    }
    const validateNNumber = (e) => {
        const data = getDataFromContext("dateOfBirth")
        const valToVlidate = e.target.value
        const dateOfBirth = data ? data.birthday : "0"
        const d = dateOfBirth && dateOfBirth.split('').splice(2).join('').split('-').join('')
        const dd = valToVlidate && valToVlidate.split('-')[0].split('.').join('')
        if (d !== dd) {
            setInputError({ id: "email", error: t('error_messages.national_number') })
            
             if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
pageID: "onboarding",
errorMessage: t('error_messages.national_number'),
trackMethod: "errorMessage"
                    }
                );
            }
        } else {
            cleanErrorMessage()
        }
    }
    const onblurHandle = (e) => {
        handleInputChange(e)
        type === "email" && onBlurValidation(e)
    }


    // Error
    const hasError = error.length > 0
    if (hasError) {
        console.log()
    }
    const getError = (id) => hasError && error.find(error => {
        return error.id === id
    } )
    const _error = name === getError(name)?.id && getError(name)

    const [inputError, setInputError] = useState(_error ? _error : false)
    const cleanErrorMessage = () => { setInputError(false) }

    // Checkbox Input
    const checkboxRef = useRef()
    const checkBox_className = "checkbox " + name
    const checkBos_error_className = inputError ? "hello-checkbox error" : "hello-checkbox"
    const [checkboxState, setCheckboxState] = useState(checked || false)

    const handleCheckbox = (e) => {
        setCheckboxState(e.target.checked)
        setInput(e.target.checked ? 1 : 0)
        
    }

     useEffect(() => {
       emitCheckbox && emitCheckbox(checkboxState)
     }, [checkboxState])
    
    const Checkbox = () => {
        return (
            <div className={checkBox_className}>
                <label className={checkBos_error_className} ref={checkboxRef}>
                    <input
                        type="checkbox"
                        name={name}
                        id={name}
                        checked={checkboxState}
                        onChange={handleCheckbox}
                        onClick={cleanErrorMessage}
                        autoComplete="off"
                    />
                    <span></span>
                </label>

                <div className={"legend"}
                    onClick={() => {
                    checkboxRef.current.click()
                    }}>
                    
                 {checkboxlabelbold ? <b> {checkboxLabel}</b> : checkboxLabel} 
              
                </div>
            </div>
        )
    }

    // postal code ///////////////////////////////////////////////////////////////
    const PostalCodeInput = () => {
        return (
            <PostalCode
                type={"text"}
                id={name}
                name={name}
                label={label}
                value={inputValue}
                getInputValue={getInputValue}
                getPostalValidity={getPostalValidity}
            />
        )
    }

    // Date input ///////////////////////////////////////////////////////////////
    const DateInputGroup = () => {
        return <DateInput
            type={type}
            id={name}
            name={name}
            label={label}
            value={inputValue}
            onChange={handleInputChange}
            notBirthdate={notBirthdate}
            noPast={noPast}
            enterpriseToCreate={enterpriseToCreate}
            noFuture={noFuture}
        />

    }

    // Phone Input ///////////////////////////////////////////////////////////////
    console.log("phoneCode => ", phoneCode)

    const getPhoneCode = (name, value) => {
        getInputValue && getInputValue("internal_mobile_country_code", value.callingCode)
        getInputValue && getInputValue("internal_mobile_country_calling_code", value.code)
    }

    const Phone = () => {
        return (
            <PhoneInput
                name={name}
                id={name}
                value={inputValue}
                country={phoneCode}
                onChange={handleInputChange}
                getPhoneCode={getPhoneCode}
                max={max}
            //onClick={cleanErrorMessage}
            />
        )
    }

    // Select Input //////////////////////////////////////////////////////////////
    const Select = () => {
        return (
            <>
                <div className={"option-list " + name}>
                    <select name={name} id={name} value={inputValue} onChange={handleInputChange}>
                        {options.map(option => (
                            <option value={option.value} key={option.value}>{option.label}</option>))}
                    </select>
                    {
                        options.map(
                            option => (<div className={option.value === defaultSelect ? "option is-active" : "option "} key={option.value}
                                onClick={() => getInputValue(name, option.value)}
                            > {option.label}</div>)
                        )
                    }
                </div>
            </>
        )
    }

    // id file input /////////////////////////////////////////////////////////////
    const iderror_className = inputError ? "error" : ""
    const idfield_ClassName = "idField" + name


    const IdInput = () => {
        return (
            <div className={idfield_ClassName}>
                <p>{ content.label }</p>
                    <label htmlFor={name} className={`id-input ${iderror_className}`}>
                        <div>
                            <p className="icon">
                            <AiOutlineCamera />
                            </p>
                            <p>
                                <span>{ content.contentTitle } </span>
                                <span>{ content.contentbody }</span>
                            </p>
                        </div>
                        <input type="file" id={name} onChange={getInputFlie} />
                </label>
                          {inputError &&
                        <p>
                            <AiFillWarning className={"warning"} size={"1.5em"} />
                            {inputError.error}
                        </p>}
                </div>
        )

    }
    

    // Other Input ////////////////////////////////////////////////////////////////
    const numOnly_ClassName = isNNumber || isBCE ? "textField num" : "textField " + name
    const error_className = inputError ? "hello-input error" : "hello-input "

    const Input = () => {
        return (
            <div className={numOnly_ClassName}>
                <label className={error_className}>
                    {!isNNumber && !isBCE &&
                        <input
                            placeholder=" "
                            type={type}
                            name={name}
                            id={name}
                            value={inputValue}
                            onChange={handleInputChange}
                            onBlur={onblurHandle} // For email instant validation
                            //onClick={cleanErrorMessage}
                            disabled={disabled}
                            maxLength={max}
                            autoComplete="off"
                        />
                    }
                    {isNNumber &&
                        <InputMask mask="99.99.99-999.99"
                            maskplaceholder={"-"}
                            name={name}
                            id={name}
                            value={inputValue}
                            onChange={handleInputChange}
                            placeholder=" "
                        onBlur={validateNNumber}
                        autoComplete="off"
                        />
                    }
                    {isBCE &&
                        <InputMask mask="9999.999.999"
                            maskplaceholder={"-"}
                            name={name}
                            id={name}
                            value={inputValue}
                            onChange={handleInputChange}
                            placeholder=" "
                            autoComplete="off"
                        />
                    }
                    <span>{label}</span>
                    {inputError &&
                        <p>
                            <AiFillWarning className={"warning"} size={"1.5em"} />
                            {inputError.error}
                        </p>}
                </label>
            </div>
        )
    }

    if (type === "checkbox") return Checkbox()
    if (type === "phone") return Phone()
    if (type === "select") return Select()
    if (type === "postCode") return PostalCodeInput()
    if (type === "date") return DateInputGroup()
    if (type === "idInput") return IdInput()
    return Input()
};

InputField.propTypes = {
    type: PropTypes.string.isRequired,
    name: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.any,
    error: PropTypes.array,
    checked: PropTypes.any,
    phoneCode: PropTypes.any,
    options: PropTypes.array,
    isNNumber: PropTypes.bool,
    isBCE: PropTypes.bool,
    getInputValue: PropTypes.func,
    max: PropTypes.number,


};

InputField.defaultProps = {
    type: "text",
    error: []
}

export default InputField
